module.exports = __webpack_public_path__ + "img/statements.4ef3455b.png";